
import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Form from '@rjsf/material-ui';
import { generateSchema } from './schema';
const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  },
  form: {
    minWidth: '400px',
    maxWidth: '400px',
    margin: '0 auto'

  }
}));

const FinalEmailModal = ({ flowConstructor, finalEmailModal, setFinalEmailModal }) => {
  useState(() => {

  }, [finalEmailModal]);

  const handleClose = () => {
    setFinalEmailModal(false);
  };

  const classes = useStyles();
  return (
    <Modal
      aria-labelledby='transition-modal-title'
      aria-describedby='transition-modal-description'
      className={classes.modal}
      open={finalEmailModal}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
    >
      <Fade in={finalEmailModal}>
        <div className={classes.paper}>
          <Form
            className={classes.form}
            schema={generateSchema()}
            onSubmit={(e) => {
              setFinalEmailModal(false);
              flowConstructor(e.formData);
            }}
          />
        </div>
      </Fade>
    </Modal>
  );
};

export default FinalEmailModal
;
